const gameParamater = require('../define/gameParamater').default;
const { APP_REBOOT, STAGE_INIT, STAGE_CONTINUE, SELECT_BOX, UNSELECT_BOX, ROTATE_BOX, PLACEMENT_BOX } = require("./actions");

const { getRandomNumFromMsec } = require('../core/rand').default;
const { getNextPorinBox, getNextRotate } = require('../core/stageData').default;
// ============================



const insertPorinBox = (selector, num, insertPorinBox) => {
    const porinBox = selector[num];
    if (porinBox && porinBox.num === num) {
        if (insertPorinBox) {
            porinBox.type = insertPorinBox.type
            porinBox.porins = insertPorinBox.porins
            porinBox.rotate = insertPorinBox.rotate
        }
        selector[num] = porinBox;
    }
    return selector;
}

const rotatePorinBox = (selector, num) => {
    const porinBox = selector[num];
    if (porinBox && porinBox.num === num) {
        porinBox.rotate = getNextRotate(porinBox.rotate);
        selector[num] = porinBox;
    }
    return selector;
}

const initializePorinBox = arrivalStage => {
    const porinBoxs = [];
    for (let i = 0; i < gameParamater.SELECTOR_NUM; i++) {
        const porinBox = getNextPorinBox(arrivalStage, i, getRandomNumFromMsec(10));
        porinBox.num = i;
        porinBoxs.push(porinBox);
    }
    return porinBoxs;
}

const initialState = {
    selector: initializePorinBox(1),
    selectorCount: gameParamater.SELECTOR_NUM,
    arrivalStage: 0
};

export function selectorState(state = initialState, action) {
    // console.log(`# selectorState: ${JSON.stringify(state)} -> ${JSON.stringify(action)}`);
    switch (action.type) {
        case APP_REBOOT:
            return initialState;
        case STAGE_INIT:
            return {
                ...state,
                selector: initializePorinBox(action.arrivalStage),
                selectorCount: gameParamater.SELECTOR_NUM,
                arrivalStage: action.arrivalStage
            }
        case STAGE_CONTINUE:
            return {
                ...state,
                selector: initializePorinBox(action.arrivalStage),
                selectorCount: gameParamater.SELECTOR_NUM,
                arrivalStage: action.arrivalStage
            }
        case ROTATE_BOX:
            const nextRotate = { ...state }
            nextRotate.selector = rotatePorinBox(
                nextRotate.selector,
                action.boxId)
            return nextRotate;
        case PLACEMENT_BOX:
            const nextPlacement = { ...state };
            const nextPorinBox = getNextPorinBox(state.arrivalStage, state.selectorCount + 1, getRandomNumFromMsec(10));
            nextPlacement.currentSelect = null;
            nextPlacement.selector = insertPorinBox(
                nextPlacement.selector,
                action.frameId,
                nextPorinBox);
            nextPlacement.selectorCount++;
            return nextPlacement;
        default:
            return state;
    }
}